import * as types from "./types";

export const getApplicantReportsRequest = (payload) => ({
  type: types.GET_APPLICANT_REPORTS_REQUEST,
  payload,
});

export const getApplicantReportsResponse = (payload) => ({
  type: types.GET_APPLICANT_REPORTS_RESPONSE,
  payload,
});

export const uploadApplicantReportsRequest = (payload) => ({
  type: types.UPLOAD_APPLICANT_REPORTS_REQUEST,
  payload,
});

export const uploadApplicantReportsResponse = (payload) => ({
  type: types.UPLOAD_APPLICANT_REPORTS_RESPONSE,
  payload,
});

export const deleteApplicantReportsRequest = (payload) => ({
  type: types.DELETE_APPLICANT_REPORTS_REQUEST,
  payload,
});

export const deleteApplicantReportsResponse = (payload) => ({
  type: types.DELETE_APPLICANT_REPORTS_RESPONSE,
  payload,
});

export const exportApplicantReportSheetRequest = (payload) => ({
  type: types.EXPORT_APPLICANT_REPORT_SHEET_REQUEST,
  payload,
});

export const exportApplicantReportSheetRequestAll = (payload) => ({
  type: types.EXPORT_APPLICANT_REPORT_SHEET_REQUEST_ALL,
  payload,
});
